import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	transition: all 0.3s ease 0s;
	&:hover {
		span {
			color: ${tokens.color_white};

			& > svg > path {
				fill: ${tokens.color_white};
			}
		}
	}
`;

export const TextSpan = styled.span`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > svg {
		margin-left: 10px;
		transform: scale(0.7);

		& > path {
			fill: ${tokens.color_primary};
		}
	}
`;
